/** Theme preference: follow the OS, or pin one.
 *
 *  The token set already supports all three states — bare `:root` is light, a
 *  `prefers-color-scheme` block covers system dark, and `[data-bujo-theme]`
 *  overrides both. This only persists the choice and stamps the attribute.
 *
 *  Settings owns this properly in U10. Until then it lives in the header so both
 *  themes can actually be tested on a device without changing OS settings.
 */

export type ThemeChoice = 'system' | 'light' | 'dark';

const KEY = 'bujo.theme.v1';

export function storedTheme(): ThemeChoice {
  const raw = localStorage.getItem(KEY);
  return raw === 'light' || raw === 'dark' ? raw : 'system';
}

export function applyTheme(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === 'system') {
    root.removeAttribute('data-bujo-theme');
    localStorage.removeItem(KEY);
  } else {
    root.setAttribute('data-bujo-theme', choice);
    localStorage.setItem(KEY, choice);
  }
}

/** system → light → dark → system. */
export function nextTheme(choice: ThemeChoice): ThemeChoice {
  return choice === 'system' ? 'light' : choice === 'light' ? 'dark' : 'system';
}
